import { render, staticRenderFns } from "./user_type.vue?vue&type=template&id=31330f3a&"
import script from "./user_type.vue?vue&type=script&lang=ts&"
export * from "./user_type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports